export function consentToDiscloseGALLES() {
return [   // Release 2026-01-05 17:12:56
 {
   page: 0,
    name: "Logo",
    type: "logo",
    top: 28.673,
    left: 53,
    width: 240,
    height: 36,
    }, 
{
   page: 0,
   name: "Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 192.27,
   left: 282.12,
   width: 235.233,
   height: 15.316
}
,
{
   page: 1,
   name: "Client Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.553,
   left: 161.4,
   width: 334.2,
   height: 14.127
}
,
{
   page: 1,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 357.865,
   left: 91.1194,
   width: 404.2366,
   height: 14.782
}
] }
